import * as propertyTypes from "../property_types.js"

export class UiGetNextNumberProps extends propertyTypes.AppBaseComponentProps {

    private urlMetadata = new propertyTypes.TextProperty("url", "Url");
    public url: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.urlMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}